(function ($) {
  Drupal.behaviors.renutriv_pink_images = {
    attach: function (context, settings) {
      // use renutriv pink images if MPP has #use-renutriv-pink-images
      if( $('#use-renutriv-pink-images').length ) {
        $('body').addClass('renutriv-pink-images');
        // get background color
        if ($('#use-renutriv-pink-images').hasClass('') === false) {
          var class_name = $('#use-renutriv-pink-images').attr('class');
          var bg_color = class_name.split('-').pop().trim();
          if (bg_color.length == 6) {
            bg_color = "#" + bg_color;
            $('.page-wrapper').css('background-color',bg_color);
          }
        }
        // replace on PC MPP
        $('.mpp__product').each(function() {
          var bgImg = $(this).find('.product_brief__image').attr('style');
          var newBgImg = bgImg.replace(/_0/g,"_0_pink");
          $(this).find('.product_brief__image').attr('style', newBgImg);
        });
        // replace on Mobile MPP
        $('.device-mobile .mpp__product-grid .product-brief').each(function() {
          var bgImg = $(this).find('.product-brief__image').attr('style');
          var newBgImg = bgImg.replace(/_0/g,"_0_pink");
          $(this).find('.product-brief__image').attr('style', newBgImg);
        });
      }
    }
  };
})(jQuery);
